pointman.define("m/sufei-zepto", ["m/emit"], function (emit) {
	'use strict';
	var $ = null;

	function isType(type) {
		return function (obj) {
			return {}.toString.call(obj) == '[object ' + type + ']';
		};
	}

	//var isObject = isType('Object');
	var isString = isType('String');

	var SufeiB2bMod = function () {
		this.cache = {
			//状态：(0)拦截中 -> (100)验证中 ->  (200)验证通过
			status: 0,
			//当前正在验证的请求
			currentRequest: null,
			//被拦截的队列
			queue: []
		};
	};

	SufeiB2bMod.prototype = {
		init: function () {
			var self = this;

			//事件：验证沟通过后重发送请求
			emit.on('event:resendRequest@sufei', function (data) {
				self.resendRequest(data);
			});

			//清空拦截队列
			emit.on('event:cleanHijackQueue@sufei', function () {
				self.cache.currentRequest = null;
				self.cache.queue = [];
				self.cache.status = 0;
			});

			//使用seajs的方法拦截所有的ajax请求
			if (window.seajs && seajs.on) {
				seajs.on('exec', function (e) {
					if (e.id.indexOf('zepto') != -1) {
						$ = e.exports;
						setup();
					}
				});
			}

			// 轮询检测 zepto   (by zjc)
			function test() {
				$ = window.$;
				if ($) setup();
			}

			var inited;
			var timer = setInterval(test, 50);
			test();

			function setup() {
				if (inited) return;
				inited = true;
				clearInterval(timer);

				//$.ajaxPrefilter(function(options, originalOptions, jqXHR){
				$(document).on('ajaxBeforeSend', function (e, xhr, options) {

					// backup options -> originalOptions   (by zjc)
					var originalOptions = {};
					$.extend(originalOptions, options);


					var oldSuccessCallback = options.success;
					var oldErrorCallback = options.error;

					options.success = function (result, statusText, xhr) {
						if (isString(result)) {
							result = $.parseJSON(result);
						}

						var s_sm = "sm";
						//判断特征
						if (result && (result.rgv587_flag0 == s_sm || result.rgv587_flag == s_sm)) {
							self.getValidateURI({
								url: result.url,
								xhrConfig: originalOptions,
								im: result.rgv587_flag == s_sm
							});
						} else {
							oldSuccessCallback && oldSuccessCallback.call(options.context || options, result, statusText, xhr);
						}
					};
					//SM拦截后固定返回json，如果原来的请求返回数据格式为script会导致ajax报错，所以需要捕获error信息
					options.error = function (jqXHR, statusText, error) {
						var resposeText = jqXHR.responseText || '';
						var result = {};
						if (resposeText.indexOf('rgv587_flag') > -1) {
							result = $.parseJSON(jqXHR.responseText);
							self.getValidateURI({
								url: result.url,
								xhrConfig: originalOptions
							});
						} else {
							oldErrorCallback && oldErrorCallback.call(options.context || options, jqXHR, statusText, error);
						}
					};
				});
			} // setup
		},

		/*
		 * ajax success或error后判断返回的数据是否有SM特征
		 * @param obj.url {string} 服务端返回的数据
		 * @param obj.xhrConfig {object} xhr
		 */
		getValidateURI: function (obj) {
			if (obj.im) {
				//this.cache.currentRequest = obj.xhrConfig;
				this.cache.currentRequest = this.cache.currentRequest || obj.xhrConfig;
				emit.fire('event:showDialog@sufei', obj.url);
			} else if (0 === this.cache.status) {
				//未开始验证时候弹出验证
				this.cache.currentRequest = obj.xhrConfig;
				//标记为正在验证
				this.cache.status = 100;

				//重新发送请求获取弹出页面地址
				if (obj.im) {
					emit.fire('event:showDialog@sufei', obj.url);
				} else {
					$.ajax({
						url: obj.url,
						dataType: 'jsonp',
						success: function (data) {
							emit.fire('event:showDialog@sufei', data.url);
						}
					});
				}
			} else {
				//已经开始验证但未结束，加入到拦截列表
				this.cache.queue.push(obj.xhrConfig);
			}
		},

		//为url增加参数
		addQueryToken: function (url, param) {
			url += (/\?/.test(url)) ? ('&' + param) : ('?' + param);
			return url;
		},

		//重新发送请求
		resendRequest: function (queryToken) {
			var self = this;
			var cache = self.cache;

			//为当前验证通过的request url增加token
			cache.currentRequest.url = self.addQueryToken(cache.currentRequest.url, queryToken);

			if ($) {
				//重新发送对于当前验证的请求
				$.ajax(cache.currentRequest);
				//重置当前验证的request
				cache.currentRequest = null;

				$.each(cache.queue, function (index, request) {
					request.url = self.addQueryToken(request.url, queryToken);
					$.ajax(request);
				});

				//清空队列
				cache.queue = [];
				//重新设置状态
				cache.status = 0;
			}
		}
	};

	return SufeiB2bMod;
});
